<template>
  <div class="scrollbar">
    <div class="container-fluid">
      <div class="row">
        <div class="col mt-2">
          <form v-on:submit.prevent="post(form)">

            <h1>Settings</h1>

            <div class="form-group" v-if="!offlineMode">

              <button class="btn btn-link btn-sm auth-reload" typ="button"
                      :disabled="fetching||!storeOffline"
                      @click="postPersonalPreferences ">
                <upload-icon></upload-icon>
                Save settings and favorites to server <span v-if="!storeOffline">(Requires offline passphrase)</span>
              </button>
              <br>
              <button class="btn btn-link btn-sm auth-reload" typ="button"
                      @click="getPersonalPreferences" :disabled="fetching||offlineMode">
                <download-icon></download-icon>
                Import settings and favorites from server
              </button>
              <br>
              <button class="btn btn-link btn-sm auth-reload" typ="button" :disabled="fetching"
                      @click="refreshAuthenticators">
                <reload-icon></reload-icon>
                Reload authenticators
              </button>
            </div>

            <hr>

            <h2>Authenticators</h2>

            <div class="form-group pb-2">
              <div class="custom-control custom-checkbox float-right">
                <input type="checkbox" class="custom-control-input" id="advanced_template"
                       v-model="form.advancedTemplate" @change="post(form)" :disabled="offlineMode">
                <label class="custom-control-label"
                       for="advanced_template">Manual input</label>
              </div>
              <label for="template_id">Authenticator template</label>
              <Select2 v-if="!form.advancedTemplate" id="template_id" v-model="form.templateId"
                       :options="possibleAuthenticatorTemplates" :disabled="offlineMode"
                       :settings="{}" @change="post(form)"/>

              <span v-if="form.advancedTemplate" class="alert alert-info mb-0 mt-2 d-block">Need help
                                <router-link to="/help" class="btn-link">how to configure secret server</router-link>?
                            </span>

              <input v-if="form.advancedTemplate" type="number" min="0" step="1" class="form-control"
                     id="template_id"
                     :disabled="offlineMode" v-model="form.templateId" @change="post(form)">


            </div>

            <div class="form-group pb-2">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="show_otp" v-model="form.show"
                       @change="post(form)">
                <label class="custom-control-label"
                       for="show_otp">Always show One Time Passwords</label>
              </div>
            </div>

            <a v-if="!showAdvanced" href="#" @click="toggleShowAdvanced">Show advanced template
              configuration</a>
            <a v-if="showAdvanced" href="#"
               @click="toggleShowAdvanced">Hide advanced template configuration</a>

            <div class="card-body border" v-if="showAdvanced">


              <a href="#" class="btn btn-sm btn-link float-right ml-2" @click="resetTemplateFilter">Reset
                to default</a>
              <p>Terms used to match possible authenticator secret templates:</p>
              <div class="input-group mb-2">
                <input type="text" class="form-control" @keyup.enter.prevent="postTemplateFilter"
                       v-model="form.newTemplateFilter">
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="button" @click="postTemplateFilter">
                    Add term
                  </button>
                </div>
              </div>
              <ul class="list-group list-group-flush mb-5">
                <li v-for="(option, i) in filterTemplateOn" class="list-group-item px-0">
                  {{option}} <a @click="removeTemplateFilter(i)" class="btn-link float-right"
                                href="#">remove</a>
                </li>
              </ul>
              <span v-if="!filterTemplateOn" class="alert alert-danger">No terms defined - requires at least one term in order to function</span>

              <a href="#" class="btn btn-sm btn-link float-right ml-2" @click="resetFieldFilter">Reset to
                default</a>
              <p>Terms used to match the secret's field which is used to generate the One Time
                Passwords.</p>

              <div class="input-group mb-2">
                <input type="text" class="form-control" @keyup.enter.prevent="postFieldFilter"
                       v-model="form.newFieldFilter">
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="button" @click="postFieldFilter">
                    Add term
                  </button>
                </div>
              </div>
              <ul class="list-group list-group-flush">
                <li v-for="(option, i) in filterFieldOn" class="list-group-item px-0">
                  {{option}} <a @click="removeFieldFilter(i)" class="btn-link float-right" href="#">remove</a>
                </li>

              </ul>
              <span v-if="!filterFieldOn" class="alert alert-danger">No terms defined - requires at least one term in order to function</span>

            </div>

            <hr>

            <h2>Offline-settings</h2>
            <p>
              Store the data offline encrypted by a password of your choosing. If disabled, your session
              is limited to
              20 minutes and you will be logged out after expiration.</p>

            <button type="button" v-if="hasOfflineStore" class="btn btn-outline-secondary ml-3 float-right"
                    @click="deleteOfflineStore">&times; Clear Offline Data
            </button>

            <p class="text-muted">
              Please note, whilst in offline mode it is not possible to retrieve new data without going
              online
              first.</p>


            <div class="form-group pb-2">
              <label for="offline_key">Offline passphrase</label>
              <div class="input-group">
                <input type="password" class="form-control" id="offline_key"
                       @keyup.enter.prevent="storeNewEncryptKey"
                       v-model="form.newKey">
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="button"
                          id="button-addon2" @click="storeNewEncryptKey">
                    Enable offline store with passphrase
                  </button>
                </div>
              </div>
            </div>

            <div class="form-group pb-2">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" :disabled="!form.offline" class="custom-control-input"
                       id="offline" v-model="form.offline"
                       @change="post(form)">
                <label class="custom-control-label" for="offline">Store offline
                  <small v-if="form.offline">(disabling this will remove any offline stored data)
                  </small>
                </label>
              </div>
            </div>

          </form>

          <hr>
          <h2>Looking for more?</h2>
          <ul>
            <li>
              <a href="#" class="btn-link" @click="showPrivacy">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="#" class="btn-link" @click="showDisclaimer">
                Disclaimer
              </a>
            </li>
            <li>

              <a href="#" class="btn-link" @click="showHelp">
                Help
              </a>
            </li>
          </ul>

          <div class="d-flex justify-content-center mb-2">
            <small>v1.2.1.1</small>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import _ from 'lodash';
  import EventHub from '../../events/event-hub';
  import {mapActions, mapGetters} from 'vuex';

  import * as Toastr from 'toastr';
  import Select2 from 'v-select2-component';
  import CryptoJS from "crypto-js";

  import DeleteIcon from "vue-material-design-icons/Delete";
  import ReloadIcon from "vue-material-design-icons/Reload";
  import DownloadIcon from "vue-material-design-icons/Download";
  import UploadIcon from "vue-material-design-icons/Upload";

  Toastr.options.timeout = 1500;
  let keySize = 256;
  let iterations = 100;

  export default {
    name: 'Settings',
    components: {
      UploadIcon,
      DownloadIcon,
      ReloadIcon,
      Select2,
      DeleteIcon
    },
    data() {
      return {
        form: {
          dispatched: {},
          fieldId: false,
          templateId: false,
          advancedTemplate: false,
          show: false,
          offline: false,
          newKey: '',
          newTemplateFilter: '',
          filterTemplateOn: [
            "auth",
          ],
          newFieldFilter: '',
          filterFieldOn: [
            "restorecode",
            "authcode",
          ],
        },
        fetching: false,
        showAdvanced: false,
      };
    },
    computed: {
      ...mapGetters({
        offlineMode: 'auth/offlineMode',
        user: 'auth/user',
        authenticators: 'authenticators/all',
        filterTemplateOn: 'authenticators/filterTemplateOn',
        personalFolderId: 'authenticators/personalFolderId',
        filterFieldOn: 'authenticators/filterFieldOn',
        secrettemplates: 'secretTemplates/all',
        getTemplateById: 'secretTemplates/getById',
        templateId: 'authenticators/templateId',
        showOtp: 'settings/showOtp',
        okey: 'settings/okey',
        advancedTemplate: 'settings/advancedTemplate',
        storeOffline: 'settings/storeOffline',
        url: 'auth/url',
        favorites: 'authenticators/favorites',
      }),
      template() {
        if (this.templateId) {
          return this.getTemplateById(this.templateId);
        }
        return false;
      },
      hasOfflineStore() {
        if (localStorage.getItem('store') === null) {
          return false;
        }
        return true;
      },
      possibleAuthenticatorTemplates() {
        if (this.secrettemplates) {
          return _.filter(this.secrettemplates, template => {
            let name = this.multiIncludes(template.text, this.filterTemplateOn);

            if (name) {
              return true;
            }
          });
        }
        return false;
      },
    },
    methods: {
      ...mapActions({
        addFieldFilter: 'authenticators/addFieldFilter',
        addTemplateFilter: 'authenticators/addTemplateFilter',
        removeFieldFilter: 'authenticators/removeFieldFilter',
        removeTemplateFilter: 'authenticators/removeTemplateFilter',
        resetTemplateFilter: 'authenticators/resetTemplateFilter',
        resetFieldFilter: 'authenticators/resetFieldFilter',
        postSecret: 'authenticators/postSecret',
        getStub: 'authenticators/getStub',
        postPreferences: 'authenticators/postPreferences',
        getPreferences: 'authenticators/getPreferences',
        putSecret: 'authenticators/putSecret',
        getSecret: 'authenticators/getSecret',
        getPersonalFolderId: 'authenticators/getPersonalFolderId',
        patchSecretField: 'authenticators/patchSecretField',
      }),
      showHelp() {
        EventHub.$emit('help-show');
      },
      showDisclaimer() {
        EventHub.$emit('disclaimer-show');
      },
      showPrivacy() {
        EventHub.$emit('privacy-show');
      },
      postPersonalPreferences(e) {
        e.preventDefault();
        if (!this.offlineMode && this.personalFolderId) {

          this.fetching = true;
          this.postPreferences()
            .then(response => {
              if (typeof response == "undefined") {
                return Toastr.error('Unable to save settings.');
              }
              return Toastr.success('Settings and favorites saved.');

            })
            .catch(() => {
              return Toastr.error('Unable to save settings.');
            })
            .finally(() => {
              this.fetching = false;
            });
        }
      },
      refreshAuthenticators(e) {
        e.preventDefault();
        this.fetching = true;
        this.$store.dispatch('authenticators/clearAll');
        this.$store.dispatch('asyncData')
          .then(() => {
            return Toastr.success('Authenticators retrieved.');
          })
          .catch(() => {
            return Toastr.error('Unable to fetch authenticators.');
          })
          .finally(() => {
            this.fetching = false;
          });
      },
      getPersonalPreferences(e) {
        e.preventDefault();

        if (!this.offlineMode && this.personalFolderId) {
          this.fetching = true;
          this.getPreferences(true)
            .then(result => {
              if (result == 0) {
                return Toastr.info('No settings found.');
              }
              if (typeof result !== 'undefined' && result >= 1) {
                this.form.offline = true;
                return Toastr.success('Settings and favorites loaded.');
              }
            })
            .finally(() => {

              this.fetching = false;
            });
        }
      },
      toggleShowAdvanced() {
        this.showAdvanced = !this.showAdvanced;
      },
      postTemplateFilter() {
        if (this.form.newTemplateFilter !== '') {
          this.addTemplateFilter(this.form.newTemplateFilter);
          this.form.newTemplateFilter = '';
        }
      },
      postFieldFilter() {
        if (this.form.newFieldFilter !== '') {
          this.addFieldFilter(this.form.newFieldFilter);
          this.form.newFieldFilter = '';
        }
      },
      deleteOfflineStore() {
        if (confirm("Do you want to remove your offline data?")) { // eslint-disable-line no-alert
          this.form.offline = false;
          this.$store.commit('settings/setOkey', null);
          this.post(this.form);
        }
      },
      post(form) {
        if (!this.offlineMode) {

          if (this.form.templateId) {
            this.$store.commit('authenticators/setTemplateId', this.form.templateId);
          }

          this.$store.commit('settings/setAdvancedTemplate', this.form.advancedTemplate);
        }

        this.$store.commit('settings/setShowOtp', this.form.show);

        this.$store.commit('settings/setStoreOffline', this.form.offline);

        if (!this.form.offline) {
          localStorage.removeItem('store');
        }

        Toastr.success('Settings saved');
      },
      multiIncludes(text, values) {
        var re = new RegExp(values.join('|'), 'i');
        return re.test(text);
      },
      storeNewEncryptKey() {
        if (this.form.newKey !== '') {
          // let key = this.encrypt(this.form.newKey, this.form.newKey);
          this.$store.commit('settings/setStoreOffline', true);
          this.$store.commit('settings/setOkey', this.form.newKey);
          this.form.newKey = '';
          this.form.offline = true;
          Toastr.success('Storing encrypted data offline is enabled.');
        }
      },
      encrypt(msg) {
        let pass = this.okey;
        var salt = CryptoJS.lib.WordArray.random(128 / 8);

        var key = CryptoJS.PBKDF2(pass, salt, {
          keySize: keySize / 32,
          iterations
        });

        var iv = CryptoJS.lib.WordArray.random(128 / 8);

        var encrypted = CryptoJS.AES.encrypt(msg, key, {
          iv,
          padding: CryptoJS.pad.Pkcs7,
          mode: CryptoJS.mode.CBC
        });

        // salt, iv will be hex 32 in length
        // append them to the ciphertext for use  in decryption
        var transitmessage = salt.toString() + iv.toString() + encrypted.toString();
        return transitmessage;
      },
      decrypt(transitmessage, pass) {
        var salt = CryptoJS.enc.Hex.parse(transitmessage.substr(0, 32));
        var iv = CryptoJS.enc.Hex.parse(transitmessage.substr(32, 32));
        var encrypted = transitmessage.substring(64);

        var key = CryptoJS.PBKDF2(pass, salt, {
          keySize: keySize / 32,
          iterations
        });

        var decrypted = CryptoJS.AES.decrypt(encrypted, key, {
          iv,
          padding: CryptoJS.pad.Pkcs7,
          mode: CryptoJS.mode.CBC

        });
        return decrypted;
      },
    },
    mounted() {
      if (this.templateId) {
        this.form.templateId = this.templateId;
      }
      if (this.fieldId) {
        this.form.fieldId = this.fieldId;
      }
      if (this.showOtp) {
        this.form.show = this.showOtp;
      }
      if (this.storeOffline) {
        this.form.offline = this.storeOffline;
        localStorage.removeItem('store');
      }
      if (this.advancedTemplate) {
        this.form.advancedTemplate = this.advancedTemplate;
      }
      if (this.filterFieldOn) {
        this.form.filterFieldOn = this.filterFieldOn;
      }
      if (!this.offlineMode) {
        this.$store.dispatch('secretTemplates/getSecretTemplates')
          .catch(e => {
            if (e.status == 400 && e.data.errorCode === "API_AccessDenied") {
              this.form.advancedTemplate = true;
            }
          });
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/pages/_Settings.vue